import { SxProps, Theme } from '@mui/system';
import { slateGrey100, slateGrey800 } from '00.app/theme';

export const searchBarContainer = (theme: Theme): SxProps => ({
  width: '100%',
  borderColor: `${theme.palette.mode === 'dark' ? slateGrey800 : slateGrey100}`,
  borderRadius: '10px',
});
